<template>
  <div class="frame-content">
    <div
      class="widget-position-right sidebar-position-right onlyBubble"
      id="chatContainer"
    >
      <div
        class="chat no-clip-path chrome moveFromRight-enter-done"
        :style="{ width: chatWidth }"
      >
        <div
          class="chat-header project-online"
          style="
            color: rgb(255, 255, 255);
            background: linear-gradient(
              135deg,
              rgb(42, 39, 218) 0%,
              rgb(0, 204, 255) 100%
            );
          "
        >
          <!-- Collapse Icon -->
          <button
            class="collapse-toggle"
            @click="toggleCollapse"
            :class="{ 'is-collapsed': isCollapsed }"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4 12L20 12M4 6L20 6M4 18L20 18"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </button>
          <div class="header-content">
            <h2 class="oneline"><span>{{ userName ? `Hi, ${userName}!` : 'Hi there!' }}</span></h2>
            <div class="subscription-status">
              <span :class="['token-count', tokenStatusClass]">
                <i class="mdi mdi-poker-chip"></i>
                <span v-if="isOutOfTokens">No questions left</span>
                <span v-else-if="isLowTokens">Questions low: {{ tokensLeft.toLocaleString() }}</span>
                <span v-else>Questions: {{ tokensLeft.toLocaleString() }}</span>
              </span>
            </div>
            <button
              class="purchase-tokens-btn"
              :class="{ 'purchase-tokens-btn--urgent': isOutOfTokens }"
              @click="openTokenModal"
            >
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="flex-shrink:0">
                <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
                <path d="M12 6v12M9 9h4.5a1.5 1.5 0 0 1 0 3H9m0 0h5a1.5 1.5 0 0 1 0 3H9" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
              Buy Questions
            </button>
          </div>
          <button
            class="material-icons exit-chat ripple tidio-1s5t5ku"
            id="minimize-button"
            type="button"
            aria-label="Minimize"
            style="color: rgb(255, 255, 255)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 0 24 24"
              width="24"
              id="ic-close"
            >
              <path d="M0 0h24v24H0z" fill="none"></path>
              <path
                d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
              ></path>
            </svg>
            <span>Minimize</span>
          </button>
        </div>

        <div id="conversation-group" role="log">
          <div
            id="messages"
            aria-live="polite"
            aria-atomic="false"
            data-testid="messagesLog"
          >
            <div v-for="(msg, index) in messages" :key="index">
              <!-- User Question: right side -->
              <div
                v-if="msg?.question"
                class="message message-user right-align"
              >
                <span class="message-content">{{ msg.question }}</span>
                <!-- <span class="user-icon">
                                    <svg width="32" height="32" viewBox="0 0 32 32">
                                        <circle cx="16" cy="16" r="15" fill="#1775ec" />
                                        <text x="16" y="21" text-anchor="middle" fill="#fff" font-size="16" font-family="Arial" dy=".3em">U</text>
                                    </svg>
                                </span> -->
              </div>
              <!-- Operator Answer: left side -->
              <div
                v-if="msg?.answer"
                class="message message-operator left-align"
              >
                <!-- <span class="operator-icon">
                                    <svg width="32" height="32" viewBox="0 0 32 32">
                                        <circle cx="16" cy="16" r="15" fill="#00ccff" />
                                        <text x="16" y="21" text-anchor="middle" fill="#fff" font-size="16" font-family="Arial" dy=".3em">A</text>
                                    </svg>
                                </span> -->
                <markdown-it class="message-content" :source="msg.answer" />

                <!-- QLD Flow Buttons -->
                <div
                  v-if="
                    msg.type === 'qld-question' &&
                    index === messages.length - 1 &&
                    qldStep !== 0
                  "
                  class="qld-options"
                >
                  <button
                    v-if="msg.step === 1"
                    class="qld-btn"
                    @click="handleQLDResponse('Yes')"
                  >
                    Yes
                  </button>
                  <button
                    v-if="msg.step === 1"
                    class="qld-btn"
                    @click="handleQLDResponse('No')"
                  >
                    No
                  </button>

                  <button
                    v-if="msg.step === 2"
                    class="qld-btn"
                    @click="handleQLDResponse('Yes')"
                  >
                    Yes
                  </button>
                  <button
                    v-if="msg.step === 2"
                    class="qld-btn"
                    @click="handleQLDResponse('No')"
                  >
                    No
                  </button>
                  <button
                    v-if="msg.step === 2"
                    class="qld-btn"
                    @click="handleQLDResponse('Unsure')"
                  >
                    Unsure
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div id="conversation-scroll">
            <div style="top: 0px; height: 55.8952px"></div>
            <!-- Loader: three jumping dots and a circle icon on right -->
            <div v-if="isLoading" class="chat-loader-wrapper">
              <span class="loader-user-icon">
                <svg width="32" height="32" viewBox="0 0 32 32">
                  <circle cx="16" cy="16" r="15" fill="#1775ec" />
                  <text
                    x="16"
                    y="21"
                    text-anchor="middle"
                    fill="#fff"
                    font-size="16"
                    font-family="Arial"
                    dy=".3em"
                  >
                    U
                  </text>
                </svg>
              </span>
              <div class="chat-loader-dots">
                <span class="dot"></span>
                <span class="dot"></span>
                <span class="dot"></span>
              </div>
            </div>
          </div>

          <div v-if="errorMessage" class="chatbot-error-modal">
            <div class="chatbot-error-content">
              <span class="chatbot-error-text">{{ errorMessage }}</span>
              <span
                class="chatbot-error-close"
                @click="errorMessage = ''"
                title="Close"
                >&times;</span
              >
            </div>
          </div>
        </div>
        <div class="input-group">
          <hr />
          <!-- <label for="stateOption"> Select State </label> -->
          <div class="state-picker-container">
            <label for="stateSelect" class="state-label">Select State</label>
            <select
              id="stateSelect"
              class="state-picker"
              v-model="selectedState"
              :class="{ error: stateError }"
            >
              <option disabled value="">Choose a state...</option>
              <option
                v-for="(state, idx) in stateOptions"
                :key="idx"
                :value="state.name"
              >
                {{ state.name }}
              </option>
            </select>
          </div>
          <!-- Out-of-questions banner -->
          <div v-if="isOutOfTokens" class="out-of-tokens-banner">
            <i class="mdi mdi-poker-chip"></i>
            <span>You've used all your questions this month.</span>
            <button class="out-of-tokens-cta" @click="openTokenModal">Top up now</button>
          </div>

          <div class="drag-active-wrapper footer-input-wrapper" :class="{ 'input-disabled': isOutOfTokens }">
            <textarea
              id="chat-input"
              v-model="message"
              @keydown.enter.prevent="submit"
              :rows="
                message.length < 100
                  ? 2
                  : 2 + Math.floor((message.length - 100) / 50) + 1
              "
              ref="chatInput"
              :placeholder="isOutOfTokens ? 'Purchase more questions to continue chatting...' : 'Hit the buttons to respond...'"
              :disabled="isOutOfTokens"
              aria-label="New message"
              data-testid="newMessageTextarea"
              @input="autoResize"
            ></textarea>
            <button
              id="SentButton"
              @click="submit"
              class="send-icon"
              title="SentButton"
              type="button"
              :disabled="isOutOfTokens"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                xml:space="preserve"
              >
                <path
                  :fill="(message.trim() && !isOutOfTokens) ? '#1775ec' : '#d7d7d7'"
                  d="M22,11.7V12h-0.1c-0.1,1-17.7,9.5-18.8,9.1c-1.1-0.4,2.4-6.7,3-7.5C6.8,12.9,17.1,12,17.1,12H17c0,0,0-0.2,0-0.2c0,0,0,0,0,0c0-0.4-10.2-1-10.8-1.7c-0.6-0.7-4-7.1-3-7.5C4.3,2.1,22,10.5,22,11.7z"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      id="chat-button"
      data-testid="widgetButton"
      class="chat-closed mobile-size__medium"
      @click="botInitialize"
    >
      <div class="buttonWave"></div>
      <button
        type="button"
        id="button-body"
        data-testid="widgetButtonBody"
        class="chrome"
        tabindex="0"
        aria-label="Open chat widget"
        style="
          background: linear-gradient(
            135deg,
            rgb(42, 39, 218),
            rgb(0, 204, 255)
          );
          box-shadow: rgba(0, 77, 255, 0.5) 0px 4px 24px;
        "
      >
        <i
          class="material-icons type1 for-closed active"
          style="color: rgb(255, 255, 255)"
        >
          <svg
            id="ic_bubble"
            fill="#FFFFFF"
            height="24"
            viewBox="0 0 24 24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
            ></path>
            <path d="M0 0h24v24H0z" fill="none"></path>
          </svg>
        </i>
      </button>
    </div>
  </div>

  <!-- Add modal for purchasing tokens just after header-content div -->
  <!-- <div v-if="showTokenModal" class="modal-backdrop-custom">
  <div class="modal-card-wrapper">
    <button class="modal-close-btn" @click="closeTokenModal">&times;</button>
    <div>Tokens</div>
      <div class="token-tabs">
        <div v-for="(option, i) in tokenOptions" :key="i" :class="['token-card', {active: selectedToken === i}]" @click="selectedToken = i">
          <div class="token-amount">{{ option.amount }}</div>
          <div class="token-price">${{ option.price }}</div>
        </div>
      </div>
      <div class="purchase-info">
        <button class="btn btn-primary mt-2" @click="purchaseToken(tokenOptions[selectedToken])">Purchase</button>
      </div>
  </div>
</div> -->

  <stripeCheckoutModel
    :isOpen="showTokenModal"
    @close="closeTokenModal"
    @success="handlePurchaseSuccess"
  />
</template>

<script>
import MarkdownIt from "vue3-markdown-it";
import stripeCheckoutModel from "../stripeCheckoutModel.vue";

export default {
  name: "ChatBot",
  components: {
    MarkdownIt,
    stripeCheckoutModel,
  },

  data() {
    return {
      message: "",
      state: "",
      messages: [], // To store chat messages
      isSubscribed: false,
      tokensLeft: 0,
      userName: "",
      selectedState: false,
      isLoading: false,
      subscription: "",
      errorMessage: "",
      stateError: "",
      isExpanded: false,
      isCollapsed: false,
      chatWidth: "30%",
      stateOptions: [
        { name: "Australia capital city" },
        { name: "New South Wales" },
        { name: "Northern territory" },
        { name: "QLD" },
        { name: "South Australia" },
        { name: "Victoria" },
        { name: "Western Australia" },
      ],
      showTokenModal: false,
      selectedToken: 0,
      tokenOptions: [
        { amount: 50, price: 10 },
      ],
      qldStep: 0, // 0: None, 1: >6 lots?, 2: Small Scheme stated?
      regulationSource: null,
      audioContext: null,
      openChatHandler: null,
      closeChatHandler: null,
    };
  },
  computed: {
    isOutOfTokens() {
      return this.tokensLeft <= 0;
    },
    isLowTokens() {
      return this.tokensLeft > 0 && this.tokensLeft < 10;
    },
    tokenStatusClass() {
      if (this.isOutOfTokens) return "token-count--empty";
      if (this.isLowTokens) return "token-count--low";
      return "token-count--ok";
    },
  },
  watch: {
    selectedState(newVal) {
      if (newVal === "QLD") {
        this.startQLDFlow();
      } else {
        this.qldStep = 0;
        this.regulationSource = null;
      }
    },
  },
  mounted() {
    const chatButton = document.getElementById("chat-button");
    const chatContainer = document.getElementById("chatContainer");
    const minimizeButton = document.getElementById("minimize-button");

    if (chatButton) {
      this.openChatHandler = () => {
        this.openChat(chatContainer, chatButton);
      };
      chatButton.addEventListener("click", this.openChatHandler);
    }

    if (minimizeButton) {
      this.closeChatHandler = () => {
        this.closeChat(chatContainer, chatButton);
      };
      minimizeButton.addEventListener("click", this.closeChatHandler);
    }

    this.$store
      .dispatch("getUserTokens")
      .then((data) => {
        this.userName = data?.userName || "";
        this.tokensLeft = data?.questionsLeft ?? this.tokensLeft;
        this.isSubscribed = data?.isSubscribed ?? this.isSubscribed;
      })
      .catch((error) => {
        console.error("Error getUserTokens:", error);
      });
  },
  beforeUnmount() {
    const chatButton = document.getElementById("chat-button");
    const minimizeButton = document.getElementById("minimize-button");

    if (chatButton && this.openChatHandler) {
      chatButton.removeEventListener("click", this.openChatHandler);
    }

    if (minimizeButton && this.closeChatHandler) {
      minimizeButton.removeEventListener("click", this.closeChatHandler);
    }
  },

  methods: {
    openChat(chatContainer, chatButton) {
      if (!chatContainer || chatContainer.classList.contains("open")) {
        return;
      }

      chatContainer.classList.add("open");
      chatButton?.classList.add("clicked");
      this.playOpenSound();
    },
    closeChat(chatContainer, chatButton) {
      if (!chatContainer) {
        return;
      }

      chatContainer.classList.remove("open");
      chatButton?.classList.remove("clicked");
    },
    createAudioContext() {
      const AudioContextClass =
        window.AudioContext || window.webkitAudioContext;

      if (!AudioContextClass) {
        return null;
      }

      if (!this.audioContext) {
        this.audioContext = new AudioContextClass();
      }

      if (this.audioContext.state === "suspended") {
        this.audioContext.resume();
      }

      return this.audioContext;
    },
    playOpenSound() {
      const audioContext = this.createAudioContext();

      if (!audioContext) {
        return;
      }

      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();
      const startTime = audioContext.currentTime;

      oscillator.type = "sine";
      oscillator.frequency.setValueAtTime(520, startTime);
      oscillator.frequency.exponentialRampToValueAtTime(780, startTime + 0.16);

      gainNode.gain.setValueAtTime(0.0001, startTime);
      gainNode.gain.exponentialRampToValueAtTime(0.07, startTime + 0.03);
      gainNode.gain.exponentialRampToValueAtTime(0.0001, startTime + 0.22);

      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);

      oscillator.start(startTime);
      oscillator.stop(startTime + 0.22);
    },
    playSendSound() {
      const audioContext = this.createAudioContext();

      if (!audioContext) {
        return;
      }

      const oscillator = audioContext.createOscillator();
      const gainNode = audioContext.createGain();
      const startTime = audioContext.currentTime;

      oscillator.type = "triangle";
      oscillator.frequency.setValueAtTime(880, startTime);
      oscillator.frequency.exponentialRampToValueAtTime(660, startTime + 0.08);

      gainNode.gain.setValueAtTime(0.0001, startTime);
      gainNode.gain.exponentialRampToValueAtTime(0.06, startTime + 0.015);
      gainNode.gain.exponentialRampToValueAtTime(0.0001, startTime + 0.12);

      oscillator.connect(gainNode);
      gainNode.connect(audioContext.destination);

      oscillator.start(startTime);
      oscillator.stop(startTime + 0.12);
    },
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
      this.chatWidth = this.isCollapsed ? "50%" : "30%";
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const container = document.getElementById("conversation-group");
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    },
    submit() {
      this.errorMessage = "";

      if (this.isOutOfTokens) {
        this.openTokenModal();
        return;
      }

      if (!this.selectedState) {
        this.errorMessage = "Please select a state before sending a message";
        return;
      }

      if (this.selectedState === "QLD" && this.qldStep !== 0) {
        this.errorMessage = "Please answer the question above first.";
        return;
      }

      if (this.message.trim() && this.selectedState) {
        this.playSendSound();
        // Add user's message to chat
        this.messages.push({ question: this.message });
        this.isLoading = true;
        this.scrollToBottom();

        // Dispatch action to send message to server
        this.$store
          .dispatch("askToChatBot", {
            question: this.message,
            state: this.selectedState,
            source: this.regulationSource,
          })
          .then((res) => {
            console.log("Response from chatbot:", res.data);
            // Add operator's response to chat
            this.messages.push({ answer: res.data.data.answer });
            this.tokensLeft = res?.data?.data?.questionsLeft;
            this.isLoading = false;
            console.log("this.messages.push--", this.messages);

            this.scrollToBottom();
          })
          .catch((error) => {
            console.error("Error sending message:", error);
            this.isLoading = false;
            this.errorMessage = error?.response?.data?.message;
          });

        // Clear input field
        this.message = "";
      }
    },
    botInitialize() {
      console.log("botInitialize--");
      // Dispatch action to send botInitialize to server
      if (!this.messages.length) {
        this.isLoading = true;
        this.$store
          .dispatch("botInitialize", { message: this.message })
          .then((res) => {
            console.log("Response from botInitialize:", res);
            // Add operator's response to chat
            // this.messages.push({ content: res.data.answer, isOperator: true });

            this.messages = res.chatBot.history;
            this.tokensLeft = (res.chatBot.freeQuestionsLeft ?? 0) + (res.chatBot.purchasedQuestionsLeft ?? 0);
            this.isSubscribed = res.chatBot.isSubscribed;
            this.subscription = res.chatBot.subscription;
            this.isLoading = false;

            this.scrollToBottom();
          })
          .catch((error) => {
            this.isLoading = false;
            console.error("Error botInitialize:", error);
          });
      }
    },
    openTokenModal() {
      const chatContainer = document.getElementById("chatContainer");
      const chatButton = document.getElementById("chat-button");
      this.closeChat(chatContainer, chatButton);
      this.showTokenModal = true;
    },
    closeTokenModal() {
      this.showTokenModal = false;
    },
    purchaseToken(option) {
      // PLACEHOLDER: Token purchase logic here
      alert(
        `You selected to purchase ${option.amount} tokens for $${option.price}`,
      );
      this.closeTokenModal();
    },
    handlePurchaseSuccess(data) {
      console.log("data--", data);
      this.messages = [];
      this.botInitialize();
      const chatContainer = document.getElementById("chatContainer");
      const chatButton = document.getElementById("chat-button");
      this.openChat(chatContainer, chatButton);
    },
    startQLDFlow() {
      this.qldStep = 1;
      this.regulationSource = null;
      this.messages.push({
        answer: "Does your complex have **MORE THAN 6 LOTS**?",
        isSystem: true,
        type: "qld-question",
        step: 1,
      });
      this.scrollToBottom();
    },
    handleQLDResponse(response) {
      // Remove the question buttons from UI (visual only, handled by template usually but here we just push user answer)
      this.messages.push({ question: response });

      if (this.qldStep === 1) {
        if (response === "Yes") {
          this.regulationSource = "Regulation_STANDARD.txt";
          this.qldStep = 0; // Flow complete, ready for questions
          this.messages.push({
            answer:
              "Thank you. I will use the **Standard Module Regulation**. How can I help you today?",
          });
        } else {
          this.qldStep = 2;
          this.messages.push({
            answer:
              "Is **Small Scheme Module** stated in your Community Management Statement?",
            isSystem: true,
            type: "qld-question",
            step: 2,
          });
        }
      } else if (this.qldStep === 2) {
        if (response === "Yes") {
          this.regulationSource = "Regulation_Small.txt";
          this.messages.push({
            answer:
              "Thank you. I will use the **Small Schemes Module Regulation**. How can I help you today?",
          });
        } else {
          this.regulationSource = "Regulation_STANDARD.txt"; // No or Unsure -> Standard
          this.messages.push({
            answer:
              "Thank you. I will use the **Standard Module Regulation**. How can I help you today?",
          });
        }
        this.qldStep = 0; // Flow complete
      }
      this.scrollToBottom();
    },
  },
};
</script>
<style scoped>
.state-picker {
  width: 100%;
  padding: 8px 14px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  color: #1e293b;
  font-size: 14px;
  margin-bottom: 8px;
  transition: all 0.2s ease;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath d='M7 10l5 5 5-5H7z' fill='%232563eb'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 14px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  height: 38px;
}

.state-picker:hover {
  border-color: #2563eb;
  background-color: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.state-picker:focus {
  border-color: #2563eb;
  outline: none;
  background-color: #ffffff;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.state-picker option {
  padding: 12px;
  font-size: 15px;
}

.state-picker.error {
  border-color: #ff4d4f;
  background-color: #fff2f0;
}

.state-picker.error:hover,
.state-picker.error:focus {
  border-color: #ff7875;
  box-shadow: 0 4px 12px rgba(255, 77, 79, 0.15);
}

.state-picker-container {
  margin-bottom: 0px;
  margin-top: 8px;
  width: 100%;
}

.state-label {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: #64748b;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.state-error-message {
  color: #dc2626;
  font-size: 13px;
  margin-top: 6px;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.state-select {
  width: 100%;
  padding: 12px 16px;
  border-radius: 12px;
  border: 2px solid #e8eef7;
  background: #f8fafd;
  color: #2c3e50;
  font-size: 15px;
  margin-bottom: 12px;
  transition: all 0.3s ease;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath d='M7 10l5 5 5-5H7z' fill='%232a27da'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 16px center;
  background-size: 16px;
  box-shadow: 0 2px 4px rgba(42, 39, 218, 0.06);
}

.state-select:hover {
  border-color: #2a27da;
  background-color: #ffffff;
  box-shadow: 0 4px 8px rgba(42, 39, 218, 0.1);
}

.state-select:focus {
  border-color: #2a27da;
  outline: none;
  background-color: #ffffff;
  box-shadow: 0 4px 12px rgba(42, 39, 218, 0.15);
}

label[for="stateOption"] {
  display: inline-block;
  font-size: 14px;
  color: #2c3e50;
  margin-bottom: 8px;
  font-weight: 500;
}

/*.frame-content {
    display: block;
    border: none;
    position: fixed;
    inset: auto 0px 0px auto;
    width: 450px;
    height: 647px;
    max-height: 100%;
    opacity: 1;
    color-scheme: none;
    background: none transparent !important;
    margin: 0px;
    max-width: 100vw;
    transform: translateY(0px);
    transition: none 0s ease 0s !important;
    visibility: visible;
    z-index: 999999999 !important;
}*/
#chat-button {
  position: fixed;
  width: 112px;
  height: 140px;
  bottom: 12px;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  pointer-events: none;
  z-index: 1;
  right: 0px;
}

#chat-button:not(.sidebar) .buttonWave {
  position: absolute;
  z-index: -1;
  width: 60px;
  height: 60px;
}

#chat-button:not(.sidebar).clicked .buttonWave::after {
  animation: 0.5s ease-out 0s 1 normal none running buttonWave;
}

#chat-button:not(.sidebar) .buttonWave::after {
  content: "";
  position: absolute;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: rgb(20, 127, 255);
  opacity: 0.5;
}

#button-body {
  width: 60px;
  height: 60px;
  border-radius: 28px;
  display: inherit;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  pointer-events: initial;
  background-size: 130% 130%;
  transition: all 0.2s ease-in-out 0s;
  position: relative;
  color: rgb(0, 125, 252);
  border: 1px solid #1e88e5;
}

#button-body::before {
  content: "";
  transition: opacity 0.5s ease-in-out 0s;
  position: absolute;
  inset: -1px;
  opacity: 0;
  border-radius: 50%;
  background-color: rgb(198, 204, 220);
}

#chat-button button i.for-closed.active {
  transform: translateX(0px);
}

#chat-button button i.for-closed {
  transform: translateX(-10px);
}

#chat-button button i.active {
  opacity: 1;
}

#chat-button button i {
  height: 26px;
  width: 26px;
  position: absolute;
  opacity: 0;
  transition: all 0.2s ease-in-out 0s;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  /* justify-content: center; */
}

i {
  user-select: none;
}

#chat-button button i.type1 svg {
  fill: currentcolor;
}

svg {
  width: 24px;
  height: 24px;
}

#chat-button button i.type1::after {
  content: "";
  position: absolute;
  width: 68px;
  height: 68px;
  border-radius: 32px;
  background: rgb(255, 255, 255);
  transition: all 0.2s ease-in-out 0s;
  transform: scale(0);
  right: -18px;
}

#chat-button button i.for-closed.active {
  transform: translateX(0px);
}

#chat-button button i.for-closed {
  transform: translateX(-10px);
}

#chat-button button i.type2 {
  width: 32px;
  height: 32px;
}

#button button i.type1.for-opened {
  width: 31px;
  height: 28px;
}

#chat-button button i.for-opened {
  transform: translateX(10px);
}

button,
button.material-icons {
  background: none;
  border: 0px;
  color: inherit;
  font-style: inherit;
  font-variant: inherit;
  font-weight: inherit;
  font-stretch: inherit;
  font-size: inherit;
  font-family: inherit;
  line-height: normal;
  overflow: visible;
  padding: 0px;
  user-select: none;
  outline: none;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

#chat-button button i.type2 svg {
  width: 32px;
  height: 32px;
  fill: rgb(0, 125, 252);
  transform: scale(0);
}

svg:not(:root) {
  overflow-clip-margin: content-box;
  overflow: hidden;
}

#button-body {
  box-shadow: rgba(0, 77, 255, 0.5) 0px 4px 24px;
}

body:not(.mobile) #button button:not(.disabled):hover i.type1 svg,
body:not(.mobile) #button button:not(.disabled):focus i.type1 svg {
  transform: scale(1.4);
}

body:not(.mobile) #button button:not(.disabled):hover i.type1::after,
body:not(.mobile) #button button:not(.disabled):focus i.type1::after {
  transform: scale(1);
}

#chat-button button i.for-closed.active {
  transform: translateX(0px);
}

.chat.chrome,
.start-group.chrome {
  box-shadow: rgba(0, 18, 46, 0.16) 0px 8px 36px 0px;
}

.chat {
  max-height: calc(100% - 47px);
  display: flex;
  flex-direction: column;
  border-radius: 30px;
}

.chat,
.start-group {
  position: fixed;
  bottom: 26px;
  border-radius: 16px;
  transition: width 0.3s ease-in-out;
  pointer-events: auto;
  box-shadow: rgba(0, 18, 46, 0.16) 0px 8px 22px 0px;
  /* overflow: hidden; */
  right: 48px;
  left: auto;
  background-color: white;
  z-index: 10000;
}

.message-operator.bots-quick-replies {
  width: 85%;
  background-color: rgb(255, 255, 255);
  margin-top: 0px;
  float: right;
}

.message-operator.bots-quick-replies .button-wrapper {
  margin-top: 0px;
  display: flex;
  flex-wrap: wrap;
  -webkit-box-pack: end;
  justify-content: flex-end;
  width: 100%;
  border: none;
}

.qld-options {
  display: flex;
  gap: 8px;
  margin-top: 8px;
  flex-wrap: wrap;
}

.qld-btn {
  background-color: #f0f0f0;
  border: 1px solid #ddd;
  padding: 6px 16px;
  border-radius: 16px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
  color: #333;
}

.qld-btn:hover {
  background-color: #e0e0e0;
  transform: translateY(-1px);
}

.message-operator {
  color: rgb(6, 19, 43);
  background: rgb(240, 242, 247);
  float: left;
}

.message {
  /* padding: 10px 16px; */
  border-radius: 20px;
  margin: 2px 0px;
  font-size: 15px;
  line-height: 20px;
  overflow-wrap: break-word;
  display: inline-block;
  max-width: 85%;
  clear: both;
  position: relative;
  transition: margin 0.28s ease-in-out 0s;
}

.input-group {
  padding: 16px;
  width: 100%;
  position: relative;
  background: rgb(255, 255, 255);
  z-index: 3;
  flex: 0 0 auto;
  box-sizing: border-box;
  border-radius: 0px 0px 16px 16px;
}
.input-group .footer-input-wrapper,
.input-group .footer-icons-wrapper {
  transition: all 0.5s ease-in-out 0s;
  opacity: 1;
  transform: translateY(0px);
  width: 100%;
}

textarea {
  border: 0px;
  width: 100%;
  font-size: 17px;
  margin: 5px 0px 14px;
  resize: none;
  line-height: 24px;
  overflow: hidden;
  -webkit-box-flex: 1;
  -ms-flex: 1 0 0px;
  flex: 1 0 0;
}

.send-icon {
  width: 44px;
  height: 44px;
  min-width: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: linear-gradient(135deg, #2a27da 0%, #00ccff 100%);
  border-radius: 22px;
  margin-left: 12px;
  transition: all 0.3s ease;
  border: none;
  box-shadow: 0 4px 15px rgba(42, 39, 218, 0.2);
  transform: translateY(0);
}

.send-icon:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(42, 39, 218, 0.3);
}

.send-icon svg {
  width: 20px;
  height: 20px;
  transform: rotate(-45deg);
}

.send-icon svg path {
  fill: white !important;
  transition: fill 0.3s ease;
}

hr {
  margin: 0px;
  border-width: 0px 0px 1px;
  border-top-style: initial;
  border-right-style: initial;
  border-left-style: initial;
  border-top-color: initial;
  border-right-color: initial;
  border-left-color: initial;
  border-image: initial;
  border-bottom-style: solid;
  border-bottom-color: rgb(219, 223, 230);
}

#conversation-group {
  padding: 0px 28px;
  width: 100%;
  height: 357px;
  overflow: hidden auto;
  background: rgb(255, 255, 255);
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  max-height: 357px;
  min-height: 160px;
  flex: 0 1 auto;
  animation: slideUpFade 0.5s ease-out;
  transform-origin: bottom;
}

@keyframes slideUpFade {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

#conversation-group::-webkit-scrollbar {
  width: 6px;
}

#conversation-group::-webkit-scrollbar-track {
  background: #f0f0f0;
  border-radius: 3px;
}

#conversation-group::-webkit-scrollbar-thumb {
  background: #2a27da;
  border-radius: 3px;
  transition: background 0.3s ease;
}

#conversation-group::-webkit-scrollbar-thumb:hover {
  background: #1775ec;
}
.message-operator.bots-quick-replies button {
  font-size: 15px;
  padding: 8px 16px;
  border: 1px solid;
  border-radius: 20px;
  margin: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: inherit;
}

.offline-message span.online::before {
  content: "";
  display: block;
  width: 8px;
  height: 8px;
  position: absolute;
  top: calc(50% - 4px);
  background: rgb(88, 183, 67);
  border-radius: 50%;
  left: 0px;
}

.no-clip-path .offline-message {
  padding: 14px 28px 20px;
}

.offline-message span {
  z-index: 2;
  position: relative;
  display: inline-block;
  font-size: 16px;
}

.message-operator.message-with-buttons .button-wrapper,
.message-operator .message-with-buttons .button-wrapper,
.message-operator.bots-quick-replies .button-wrapper {
  background: rgb(255, 255, 255);
  width: 100%;
  margin-top: 10px;
  /* border-width: 0px 1px 1px;
        border-right-style: solid;
        border-bottom-style: solid;
        border-left-style: solid;
        border-right-color: rgb(235, 238, 240);
        border-bottom-color: rgb(235, 238, 240);
        border-left-color: rgb(235, 238, 240);*/
  border-image: initial;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  border-top-style: initial;
  border-top-color: initial;
  position: relative;
}

#chat-button button i.for-opened.active {
  transform: translateX(0px);
}
.message-operator.bots-quick-replies .sent {
  font-size: 15px;
  padding: 8px 16px;
  border: none;
  border-radius: 20px;
  margin: 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: inherit;
}
.message-operator.message-with-buttons .sent,
.message-operator .message-with-buttons .sent,
.message-operator.bots-quick-replies .sent {
  margin: 0px auto;
  min-width: 100%;
  display: block;
  font-size: 16px;
  line-height: 19px;
  padding: 8px 16px;
  color: rgb(0, 125, 252);
  background: #f2f9ff;
  position: relative;
  z-index: 2;
  outline: none;
  border-radius: 20px;
  font-weight: normal;
}

.chat-header {
  padding: 16px 20px;
  background: linear-gradient(-61deg, rgb(0, 224, 216), rgb(32, 29, 142));
  position: relative;
  z-index: 4;
  flex: 0 0 auto;
  min-height: 48px;
  display: flex;
  align-items: center;
  gap: 16px;
  border-radius: 16px 16px 0px 0px;
}

.collapse-toggle {
  position: absolute;
  top: 40px;
  left: -20px;
  background: #fff !important;
  border: none;
  padding: 8px;
  cursor: pointer;
  border-radius: 6px;
  color: #2344e1;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 5;
  border-radius: 50%;
}

.collapse-toggle:hover {
  background: rgba(255, 255, 255, 0.1);
}

.collapse-toggle svg {
  transition: transform 0.3s ease;
}

.collapse-toggle.is-collapsed svg {
  transform: rotate(-90deg);
}

.header-content {
  padding-right: 40px;
  padding-left: 20px;
  width: 100%;
}

.subscription-status {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  margin-top: 6px;
  display: flex;
  /* flex-direction: column; */
  gap: 10px;
}

/* Token count color states */
.token-count {
  font-size: 13px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.token-count--ok {
  color: rgba(255, 255, 255, 0.95);
}
.token-count--low {
  color: #ffe066;
}
.token-count--empty {
  color: #ff6b6b;
}

/* Out-of-tokens banner */
.out-of-tokens-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 6px 12px 2px;
  padding: 8px 12px;
  background: #fff3f3;
  border: 1px solid #ffc5c5;
  border-radius: 8px;
  font-size: 13px;
  color: #c0392b;
}
.out-of-tokens-banner svg {
  flex-shrink: 0;
}
.out-of-tokens-cta {
  margin-left: auto;
  padding: 4px 12px;
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  background: #e74c3c;
  border: none;
  border-radius: 14px;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s;
}
.out-of-tokens-cta:hover {
  background: #c0392b;
}

/* Disabled input area */
.input-disabled {
  opacity: 0.55;
  pointer-events: none;
}

/* Urgent purchase button — pulses when tokens are zero */
@keyframes pulse-ring {
  0%   { box-shadow: 0 0 0 0 rgba(255, 107, 107, 0.6); }
  70%  { box-shadow: 0 0 0 7px rgba(255, 107, 107, 0); }
  100% { box-shadow: 0 0 0 0 rgba(255, 107, 107, 0); }
}
.purchase-tokens-btn--urgent {
  animation: pulse-ring 1.4s ease-out infinite;
  background: #ffe5e5 !important;
  color: #c0392b !important;
}

.purchase-tokens-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  padding: 5px 12px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.3px;
  color: rgb(42, 39, 218);
  background: rgba(255, 255, 255, 0.95);
  border: none;
  border-radius: 20px;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  transition: background 0.2s, transform 0.1s, box-shadow 0.2s;
  white-space: nowrap;
}

.purchase-tokens-btn:hover {
  background: #ffffff;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.25);
  transform: translateY(-1px);
}

.purchase-tokens-btn:active {
  transform: translateY(0);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
}

.avatars-wrapper {
  width: 52px;
  height: 52px;
  margin: 0px 18px 0px 0px;
  float: left;
}

.chat h2.oneline {
  margin-top: 0px;
  line-height: 40px;
  min-height: 40px;
}

.chat h2 {
  font-size: 18px;
  font-weight: 600;
  color: currentcolor;
  margin: 0;
  padding: 0px;
  display: inline-block;
  position: relative;
  max-width: calc(100% - 145px);
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  vertical-align: bottom;
}

.chat h2 .emoji {
  width: 31px;
  height: 31px;
}

button.material-icons.exit-chat,
label.material-icons.exit-chat {
  margin-right: -3px;
}
button.material-icons.options,
button.material-icons.exit-chat,
label.material-icons.options,
label.material-icons.exit-chat {
  z-index: unset;
}

button.material-icons.exit-chat {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  transition: all 0.3s ease;
  z-index: 10;
}

button.material-icons.exit-chat:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: rotate(90deg);
}

button.material-icons.exit-chat svg {
  width: 20px;
  height: 20px;
  fill: white;
  transition: all 0.3s ease;
}

button.material-icons.exit-chat:hover svg {
  transform: scale(1.1);
}
button.material-icons svg#ic-minimize,
button.material-icons svg.options-icon,
label.material-icons svg#ic-minimize,
label.material-icons svg.options-icon {
  fill: currentcolor;
}

.tidio-1s5t5ku span {
  background: rgb(255, 255, 255);
  padding: 6px 8px;
  border-radius: 2px;
  box-shadow: rgba(0, 18, 46, 0.32) 0px 2px 8px 0px;
  font-size: 13px;
  position: absolute;
  opacity: 0;
  pointer-events: none;
  white-space: nowrap;
  transition: all 0.16s ease-in-out 0s;
  z-index: 1;
  right: calc(100% + 10px);
  top: 50%;
  transform: translate(5px, -50%);
  color: rgb(6, 19, 43);
}

.offline-message {
  margin: 12px 0;
  color: currentcolor;
  width: 100%;
  padding: 12px 16px;
  position: relative;
  background-size: 100%;
  z-index: 1;
  box-sizing: border-box;
}

.no-clip-path .offline-message {
  padding: 14px 28px 20px;
}

.offline-message span.online {
  padding-left: 20px;
}

.no-clip-path .offline-message::after {
  content: "";
  position: absolute;
  width: calc(100% + 10px);
  bottom: -8px;
  left: -5px;
  border-image-source: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNzIgMTUiPgogIDxwYXRoIGQ9Ik0zNDkuOCAxLjRDMzM0LjUuNCAzMTguNSAwIDMwMiAwaC0yLjVjLTkuMSAwLTE4LjQuMS0yNy44LjQtMzQuNSAxLTY4LjMgMy0xMDIuMyA0LjctMTQgLjUtMjggMS4yLTQxLjUgMS42Qzg0IDcuNyA0MS42IDUuMyAwIDIuMnY4LjRjNDEuNiAzIDg0IDUuMyAxMjguMiA0LjEgMTMuNS0uNCAyNy41LTEuMSA0MS41LTEuNiAzMy45LTEuNyA2Ny44LTMuNiAxMDIuMy00LjcgOS40LS4zIDE4LjctLjQgMjcuOC0uNGgyLjVjMTYuNSAwIDMyLjQuNCA0Ny44IDEuNCA4LjQuMyAxNS42LjcgMjIgMS4yVjIuMmMtNi41LS41LTEzLjgtLjUtMjIuMy0uOHoiIGZpbGw9IiNmZmYiLz4KPC9zdmc+Cg==);
  border-image-slice: 0 0 100%;
  border-image-width: 0 0 15px;
  border-image-repeat: stretch;
  border-width: 0px 0px 15px;
  border-bottom-style: solid;
  border-color: initial;
  border-top-style: initial;
  border-left-style: initial;
  border-right-style: initial;
}

.input-group .footer-input-wrapper,
.input-group .footer-icons-wrapper {
  transition: all 0.5s ease-in-out 0s;
  opacity: 1;
  transform: translateY(0px);
}

.send-icon:hover svg path {
  fill: #1775ec;
}

.message-operator {
  color: rgb(6, 19, 43);
  /* background: rgb(240, 242, 247); */
  float: left;
}
.message span.message-content {
  white-space: pre-line;
}
#chatContainer {
  transition: all 0.3s ease-in-out;
  right: -300px;
}

#chat-input {
  background: #f0fcff;
  border-radius: 30px;
  padding: 12px 20px;
  font-size: 16px;
  height: 50px;
}

.onlyBubble {
  display: none;
  transition: all 0.3s ease-in-out;
}

.open {
  display: block;
  transition: all 0.3s ease-in-out;
}

#chatContainer.open {
  right: 0;
}

.footer-input-wrapper {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.clicked {
  display: none !important;
}

#button:not(.sidebar).clicked .buttonWave::after {
  animation: 0.5s ease-out 0s 1 normal none running buttonWave;
}
#button:not(.sidebar) .buttonWave::after {
  content: "";
  position: absolute;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: rgb(20, 127, 255);
  opacity: 0.5;
}

.sentText {
  margin: 0px auto;
  min-width: 100%;
  display: block;
  font-size: 16px;
  line-height: 19px;
  padding: 8px 16px;
  color: rgb(0, 125, 252);
  background: #f2f9ff;
  position: relative;
  z-index: 2;
  outline: none;
  border-radius: 20px;
  font-weight: normal;
  margin: 10px;
}

.botText {
  color: rgb(6, 19, 43);
  background: rgb(240, 242, 247);
  padding: 10px 16px;
  border-radius: 20px;
  margin: 2px 0px;
  font-size: 15px;
  line-height: 20px;
  overflow-wrap: break-word;
  display: inline-block;
  max-width: 85%;
  clear: both;
  position: relative;
  transition: margin 0.28s ease-in-out 0s;
}

.svgsent svg path {
  fill: #1775ec;
}
#messages {
  display: flex;
  flex-direction: column;
}
.message {
  border-radius: 20px;
  margin: 2px 0;
  font-size: 15px;
  line-height: 20px;
  max-width: 100%;
  display: inline-block;
  animation: messageSlide 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  transform-origin: center;
}

@keyframes messageSlide {
  from {
    opacity: 0;
    transform: translateY(15px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.message-user {
  /* background-color: #d1f7c4; */
  align-self: flex-end;
}

.message-operator {
  background-color: inherit !important;
  align-self: flex-start;
}

.markdown-body h1,
h2,
h3 {
  font-weight: bold;
}
.markdown-body ul {
  margin-left: 1rem;
}

.right-align {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-bottom: 8px;
  width: 100%;
}

.left-align {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 8px;
  width: 100%;
}

.user-icon,
.operator-icon,
.loader-user-icon {
  margin: 4px 8px;
  display: flex;
  align-items: center;
}

.message-user .message-content {
  background: linear-gradient(135deg, #2a27da 0%, #00ccff 100%);
  color: white;
  border-radius: 16px 16px 4px 16px;
  padding: 12px 16px;
  max-width: 70%;
  margin: 4px 0;
  box-shadow: 0 2px 8px rgba(42, 39, 218, 0.2);
  display: inline-block;
  animation: userMessageSlide 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  transform-origin: bottom right;
}

.message-operator .message-content {
  background: #f0fcff;
  color: #1a1f36;
  border-radius: 16px 16px 16px 4px;
  padding: 12px 16px;
  max-width: 70%;
  margin: 4px 0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  display: inline-block;
  animation: operatorMessageSlide 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  transform-origin: bottom left;
}

@keyframes userMessageSlide {
  from {
    opacity: 0;
    transform: translateX(20px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateX(0) scale(1);
  }
}

@keyframes operatorMessageSlide {
  from {
    opacity: 0;
    transform: translateX(-20px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateX(0) scale(1);
  }
}
.chat-loader-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 10px;
}
.chat-loader-dots {
  display: flex;
  align-items: flex-end;
  margin-right: 8px;
}
.chat-loader-dots .dot {
  width: 8px;
  height: 8px;
  margin: 0 2px;
  background: #1775ec;
  border-radius: 50%;
  display: inline-block;
  animation: chat-bounce 1.2s infinite both;
}
.chat-loader-dots .dot:nth-child(2) {
  animation-delay: 0.2s;
}
.chat-loader-dots .dot:nth-child(3) {
  animation-delay: 0.4s;
}
@keyframes chat-bounce {
  0%,
  80%,
  100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
}

.chatbot-error-modal {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  animation: slideIn 0.3s ease;
}

.chatbot-error-content {
  background: #fff2f0;
  color: #cf1322;
  padding: 16px 48px 16px 20px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 280px;
  max-width: 400px;
  position: relative;
  display: flex;
  align-items: center;
  border: 1px solid #ffccc7;
}

.chatbot-error-text {
  font-size: 14px;
  font-weight: 500;
  color: #cf1322;
  word-break: break-word;
  line-height: 1.5;
}

.chatbot-error-close {
  cursor: pointer;
  font-size: 18px;
  font-weight: bold;
  color: #cf1322;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 16px;
  transition: opacity 0.2s;
  opacity: 0.7;
  padding: 4px;
}

.chatbot-error-close:hover {
  opacity: 1;
}

/* Chat Open Animation Keyframes */
@keyframes slideIn {
  0% {
    transform: translateX(100%);
    opacity: 0;
  }
  50% {
    transform: translateX(-10%);
    opacity: 0.8;
  }
  75% {
    transform: translateX(5%);
    opacity: 0.9;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

/* Bounce Animation */
@keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-20px);
  }
  60% {
    transform: translateY(-10px);
  }
}

/* Fade and Scale Animation */
@keyframes fadeScale {
  0% {
    opacity: 0;
    transform: scale(0.8);
  }
  50% {
    opacity: 0.5;
    transform: scale(1.1);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

/* Rotate Animation */
@keyframes rotateIn {
  0% {
    transform: rotate(-180deg) scale(0);
    opacity: 0;
  }
  100% {
    transform: rotate(0) scale(1);
    opacity: 1;
  }
}

/* Pulse Animation */
@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(42, 39, 218, 0.4);
  }
  70% {
    transform: scale(1.05);
    box-shadow: 0 0 0 10px rgba(42, 39, 218, 0);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(42, 39, 218, 0);
  }
}
.modal-backdrop-custom {
  position: fixed;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.6);
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-card-wrapper {
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 6px 40px rgba(42, 39, 218, 0.1);
  padding: 2rem;
  min-width: 330px;
  max-width: 95vw;
  text-align: center;
  position: relative;
}
.modal-close-btn {
  position: absolute;
  top: 0.7rem;
  right: 1.3rem;
  font-size: 2rem;
  background: none;
  border: none;
  color: #a7a7c6;
  cursor: pointer;
}
.token-tabs {
  display: flex;
  gap: 1rem;
  margin-bottom: 1.2rem;
}
.token-card {
  padding: 1rem 1.7rem;
  background: #f6f8fc;
  border: 1.5px solid #ededed;
  border-radius: 10px;
  cursor: pointer;
  flex: 1 1 0;
  transition: box-shadow 0.18s, border-color 0.17s;
}
.token-card.active {
  border-color: #2a27da;
  box-shadow: 0 8px 32px rgba(0, 90, 255, 0.09);
}
.token-amount {
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}
.token-price {
  font-size: 1.13rem;
  color: #2a27da;
  font-weight: 500;
}
.purchase-info {
  margin-top: 1.2rem;
}

/* Mobile: the widget's fixed 30%/50% inline width and bottom-anchored-
   only positioning assume a wide desktop viewport. On a phone that's a
   sliver a few dozen pixels wide, and with no top constraint the panel
   can grow tall enough to push its own header off the top of the
   screen. Turn it into a full-width floating sheet instead. The
   collapse/expand toggle (which just swaps between 30% and 50%) is
   hidden since width is fixed to the viewport here; it also renders
   partly off-screen to the left once the panel spans edge-to-edge. */
@media (max-width: 767px) {
  .chat,
  .start-group {
    top: 12px;
    left: 12px;
    right: 12px;
    bottom: 12px;
    width: auto !important;
    max-height: none;
  }
  .chat {
    max-height: none;
  }
  #conversation-group {
    height: auto;
    max-height: none;
    flex: 1 1 auto;
  }
  .collapse-toggle {
    display: none;
  }
  .chat-header {
    border-radius: 12px 12px 0 0;
  }
  .input-group {
    border-radius: 0 0 12px 12px;
  }
  #chat-button {
    width: 84px;
    height: 108px;
    bottom: 8px;
  }
  #button-body {
    width: 52px;
    height: 52px;
  }
  .message-operator .message-content {
    max-width: 100%;
  }
}
</style>
